import styled from '@emotion/styled'

import { Entry } from './Entry'
import { TimeReport } from './time-report.type'
import { Color, theme } from '../../constants'
import { useTranslations } from '../../translate'
import { ActionCard } from '../ActionCard'
import { Div } from '../Div'
import { Flex } from '../Flex'

const Timeline = styled(Div)({
  width: 2,
  height: '100%',
  background: Color.DARK_MEDIUM_GREY,
  position: 'absolute',
  left: 23,
  zIndex: 0,
})

type TimeReportLogProps = {
  reports: TimeReport[]
}

export const TimeReportLog = (props: TimeReportLogProps) => {
  const t = useTranslations()

  // Reports are returned from backend from newest to oldest
  const ascendingReports = [...props.reports].reverse()

  return (
    <ActionCard as="plain" width={295}>
      <ActionCard.Header title={t.timesheets.time_report_log()} />
      <ActionCard.Body
        styles={{
          borderTop: theme.border.style.thinLight,
          overflowY: 'auto',
          maxHeight: 350,
          paddingBottom: theme.spacing[2],
        }}
      >
        <Flex col gap={3.5} styles={{ position: 'relative', px: 2 }}>
          <Timeline />
          <Div styles={{ height: theme.spacing[1] }} />
          {ascendingReports.map((report, index) => (
            <Entry
              key={report.id}
              previousReport={ascendingReports[index - 1]}
              report={report}
            />
          ))}
        </Flex>
      </ActionCard.Body>
    </ActionCard>
  )
}
